export default __webpack_public_path__ + "static/media/install_yourapp.ee1952d0.png";